import { environment } from "@config";
import { Intercom as IntercomSDK } from "@intercom/messenger-js-sdk";

const init = ({ user_id, name, email }: { user_id?: string; name?: string; email?: string }) => {
  IntercomSDK({
    app_id: environment.intercom.appId,
    user_id,
    name,
    email,
  });
};

const showChat = () => {
  if (!window?.Intercom) {
    init({});
  }
  window?.Intercom?.("show");
};

const showNewMessage = (message?: string) => {
  window?.Intercom?.("showNewMessage", message);
};

const hideChat = () => {
  window?.Intercom?.("hide");
};

const showLauncher = () => {
  window?.Intercom?.("update", { hide_default_launcher: true });
};

const hideLauncher = () => {
  window?.Intercom?.("update", { hide_default_launcher: false });
};

const shutdown = () => {
  window?.Intercom?.("shutdown");
};

export const Intercom = {
  init,
  showChat,
  showNewMessage,
  hideChat,
  showLauncher,
  hideLauncher,
  shutdown,
};
